import React, { createContext, useContext, useMemo } from 'react';

const CaseDataContext = createContext(null);

export function useCaseDataContext() {
  return useContext(CaseDataContext);
}

export function CaseDataProvider({
  caseId,
  caseData,
  jurors,
  disabled = false,
  children,
}) {
  const value = useMemo(() => {
    if (disabled) {
      return null;
    }

    return { caseId, caseData, jurors };
  }, [caseId, caseData, disabled, jurors]);

  return (
    <CaseDataContext.Provider value={value}>
      {children}
    </CaseDataContext.Provider>
  );
}
